/** Rows per page for the order tables. */
export const TABLE_PAGE_SIZE = 12;

export const getMapCredentials = () => ({
    app_id: '8jeQSGv5cilgzlWhwAJM',
    apikey: import.meta.env.VITE_MAP_SERVICE_API_KEY,
});
